import React from 'react';
import I18n from 'i18n-js';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import experiments from '@reverbdotcom/commons/src/experiments';

import URLHelpers from '../../shared/url_helpers';
import listIt from '../../../../images/sell-flow/list-it.svg';
import sellIt from '../../../../images/sell-flow/sell-it.svg';
import shipIt from '../../../../images/sell-flow/ship-it.svg';

interface IHomepageSellVisibilityV2Card {
  iconSrc: string;
  iconAlt: string;
  cardTitle: string;
  cardBody: string;
}

function HomepageSellVisibilityV2Card({
  iconSrc,
  iconAlt,
  cardTitle,
  cardBody,
} :IHomepageSellVisibilityV2Card) {

  const backgroundImage = 'https://reverb-res.cloudinary.com/image/upload/v1641407740/fxltmj3h1glcpbrdejdn';

  return (
    <li className="homepage-sell-visibility-v2__card" style={{ backgroundImage: `url("${backgroundImage}")` }}>
      <div className="homepage-sell-visibility-v2__icon-container">
        <img
          src={iconSrc}
          alt={iconAlt}
          className="homepage-sell-visibility-v2__icon"
        />
      </div>
      <div className="homepage-sell-visibility-v2__card-content">
        <h2 className="homepage-sell-visibility-v2__card-title">
          {cardTitle}
        </h2>
        <div>
          {cardBody}
        </div>
      </div>
    </li>
  );
}

export default function HomepageSellVisibilityV2() {

  const COMPONENT_NAME = 'HomepageSellVisibilityV2';
  const user = useUser();

  useViewTracking({
    componentName: COMPONENT_NAME,
    eventName: MParticleEventName.ComponentView,
    experiments: formatExperimentsForEventAttributes(user, [
      experiments.HOMEPAGE_SELL_VISIBILITY_V3,
    ]),
  }, true);

  return (
    <div className="homepage-container__component-wrapper">
      <div className="site-wrapper">
        <div className="homepage-sell-visibility-v2">
          <div className="homepage-sell-visibility-v2__header">
            <h3>
              {I18n.t('discovery.homepage.sellVisibilityV2.anyOneCanSell')}
            </h3>
            <CoreLink
              to={URLHelpers.sellFormSearchPath()}
              className="homepage-sell-visibility-v2__button"
              clickEvent={{
                componentName: COMPONENT_NAME,
                entityId: URLHelpers.sellFormSearchPath(),
                entityType: 'url',
                eventName: MParticleEventName.ClickedComponent,
              }}
            >
              {I18n.t('discovery.homepage.sellVisibilityV2.sellYourGear')}
            </CoreLink>
          </div>
          <ol className="homepage-sell-visibility-v2__content">
            <HomepageSellVisibilityV2Card
              iconSrc={listIt}
              iconAlt={I18n.t('discovery.homepage.sellVisibilityV2.listItAlt')}
              cardTitle={I18n.t('discovery.homepage.sellVisibilityV2.listIt')}
              cardBody={I18n.t('discovery.homepage.sellVisibilityV2.dataFromPastSales')}
            />
            <HomepageSellVisibilityV2Card
              iconSrc={sellIt}
              iconAlt={I18n.t('discovery.homepage.sellVisibilityV2.sellItAlt')}
              cardTitle={I18n.t('discovery.homepage.sellVisibilityV2.sellIt')}
              cardBody={I18n.t('discovery.homepage.sellVisibilityV2.millionsOfHighQuality')}
            />
            <HomepageSellVisibilityV2Card
              iconSrc={shipIt}
              iconAlt={I18n.t('discovery.homepage.sellVisibilityV2.shipItAlt')}
              cardTitle={I18n.t('discovery.homepage.sellVisibilityV2.shipIt')}
              cardBody={I18n.t('discovery.homepage.sellVisibilityV2.fromBoxes')}
            />
          </ol>
          <div className="homepage-sell-visibility-v2__footer">
            <CoreLink
              to={URLHelpers.sellFormSearchPath()}
              className="homepage-sell-visibility-v2__button homepage-sell-visibility__button--mobile"
              clickEvent={{
                componentName: COMPONENT_NAME,
                entityId: URLHelpers.sellFormSearchPath(),
                entityType: 'url',
                eventName: MParticleEventName.ClickedComponent,
              }}
            >
              {I18n.t('discovery.homepage.sellVisibilityV2.sellYourGear')}
            </CoreLink>
          </div>
        </div>
      </div>
    </div>
  );
}
